function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 295"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 381",
  d: "M32.287 33.731l-8.6-9V18.9c0-13.655-6.723-18.609-7.008-18.813L16.557 0h-.374l-.122.087c-.286.2-7.009 5.158-7.009 18.813v5.754L.409 33.709a1.279 1.279 0 00-.413.94v5.069a1.278 1.278 0 00.546 1.048 1.265 1.265 0 00.728.229 1.345 1.345 0 00.464-.084l7.318-3.077v.612a1.28 1.28 0 001.279 1.278h.153v2.1a1.405 1.405 0 001.4 1.4h8.965a1.405 1.405 0 001.4-1.4v-2.1h.153a1.28 1.28 0 001.278-1.278v-.583l7.271 3.057a1.278 1.278 0 001.716-1.2v-5.07a1.262 1.262 0 00-.38-.919zm-30.892 6.31a.342.342 0 01-.459-.322V34.65a.366.366 0 01.132-.273l7.987-8.367v10.81zm19.928 1.781a.468.468 0 01-.468.468H11.89a.468.468 0 01-.468-.468v-2.1h9.9zm1.432-3.375a.343.343 0 01-.342.342h-5.572V27.1h-.936v11.686h-5.571a.343.343 0 01-.343-.342V18.9c0-11.712 5.207-16.852 6.383-17.862a14.948 14.948 0 013.07 3.846c1.511 2.6 3.311 7.145 3.311 14.016zm8.991 1.272A.339.339 0 0131.6 40a.334.334 0 01-.292.05l-7.612-3.2V26.081l7.94 8.316a.342.342 0 01.111.253zM20.124 11.946h-.936a2.812 2.812 0 10-5.623 0h-.936a3.748 3.748 0 117.495 0z",
  fill: "#3c00dc"
}));

function SvgProductinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.678,
    height: 43.226,
    viewBox: "0 0 32.678 43.226"
  }, props), _ref);
}

export default SvgProductinline;